import { STATS } from "@/mocks/content";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[720px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=cinematic%20moody%20investigative%20newsroom%20background%20with%20depth%2C%20abstract%20dark%20tonal%20composition%20of%20press%20conference%20microphones%20and%20camera%20flashes%20in%20silhouette%2C%20deep%20charcoal%20and%20warm%20crimson%20red%20ambient%20glow%2C%20film%20noir%20atmosphere%2C%20dramatic%20highlight%20on%20center%2C%20mysterious%20and%20editorial%2C%20strong%20contrast%20against%20light%20text&seq=hero-newsroom&width=1920&height=1080&orientation=landscape"
        alt="爆源娱乐深挖幕后来源的暗红新闻编辑部背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/40"></div>

      <div className="relative mx-auto flex min-h-[720px] w-full max-w-[1400px] flex-col justify-end px-4 pt-32 pb-16 md:px-6 md:pt-40 md:pb-20">
        <div className="max-w-3xl animate-fadeUp">
          <div className="mb-5 flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-flashlight-fill"></i> 独家调查
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200/40 bg-white/5 px-3 py-1 text-xs font-medium text-foreground-200">
              <i className="ri-shield-user-line"></i> 信源分级 · 可追溯
            </span>
          </div>

          <p className="mb-4 text-sm font-semibold tracking-[0.3em] text-accent-400 md:text-base">
            娱乐爆料 · 知情人士揭秘 · 深挖幕后来源
          </p>
          <h1 className="font-heading text-3xl leading-tight font-black text-foreground-50 md:text-5xl md:leading-[1.15]">
            不只看到热搜
            <br />
            <span className="text-primary-400">更要看清爆料背后的链条</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-200 md:text-lg">
            对话知情人士、追踪狗仔线索、解析记者报道，我们把每条传闻拆回它的来处。用内部视角还原娱乐圈不为人知的运作规则，给你一份可以追到底的真相。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#deep"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              进入独家调查 <i className="ri-arrow-down-line ml-2"></i>
            </a>
            <a
              href="#source"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-200/50 bg-white/5 px-6 py-3 text-sm font-semibold text-foreground-100 transition-colors hover:bg-white/10"
            >
              揭秘来源链条
            </a>
          </div>
        </div>

        <dl className="mt-12 grid w-full grid-cols-2 gap-x-6 gap-y-6 border-t border-white/15 pt-8 md:grid-cols-4">
          {STATS.map((s) => (
            <div key={s.label}>
              <dd className="font-heading text-3xl font-black text-foreground-50 md:text-4xl">{s.num}</dd>
              <dt className="mt-1 text-xs font-medium text-foreground-400 md:text-sm">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}